// extracted by mini-css-extract-plugin
module.exports = {"w1cg7uq0":"w1cg7uq0","s1trgvaz":"s1trgvaz"};